module.exports = __webpack_public_path__ + "img/cabinet_on.9b24f632.svg";